import React from "react";
import ScreenSelector from "@icarius-common/screenSelector";
import paths from "@icarius-router/paths";
import { getLocalizedString } from "@icarius-localization/strings";
import {
  ContractorIcon,
  ThirdPartyClassificationIcon,
  ThirdPartyIcon,
  BenefitsCenterIcon,
} from "@icarius-icons/";

const ThirdPartySettings = () => {

  const data = [
    {
      name: getLocalizedString("contractorSettings"),
      icon: <ContractorIcon />,
      path: paths.contractorSettings,
    },
    {
      name: getLocalizedString("thirdPartyClassification"),
      icon: <ThirdPartyClassificationIcon />,
      path: paths.thirdPartyClassification,
    },
    {
      name: getLocalizedString("thirdParty"),
      icon: <ThirdPartyIcon />,
      path: paths.thirdParty,
    },
    {
      name: getLocalizedString("bankSettings"),
      icon: <BenefitsCenterIcon />,
      path: paths.bankSettings,
    },
  ];
  return (
    <ScreenSelector
      title={getLocalizedString("thirdPartySettings")}
      data={data}
    />
  );
}

export default ThirdPartySettings;
